import { atom } from 'recoil'

export const modalCopy = atom({
  key: 'WorkflowsListModalCopyState',
  default: {
    show: false,
    idWorkflow: undefined,
    fetchData: false
  }
})

export const modalSimulate = atom({
  key: 'WorkflowsListModalSimulate',
  default: {
    show: false,
    idWorkflow: undefined,
    idSimulate: undefined,
    fetchData: false,
    currentIteration: 0,
    interval: 0,
    simulateStatus: undefined,
    simulateTotalCount: undefined,
    simulateDiscarded: undefined
  }
})

export const modalStatus = atom({
  key: 'WorkflowsListModalStatus',
  default: {
    show: false
  }
})

export const modalCopyWarning = atom({
  key: 'WorkflowsListModalCopyWarning',
  default: {
    show: false,
    idWorkflow: undefined
  }
})

export const modalDelete = atom({
  key: 'WorkflowsListModalDelete',
  default: {
    show: false,
    idWorkflow: undefined,
    name: undefined
  }
})
